import { Link } from "react-router-dom";
import { Header } from "@/sections/Header";
import { Footer } from "@/sections/Footer";
import { useLang } from "@/i18n/LanguageContext";

// Render plain text with URLs auto-linkified
const URL_REGEX = /(https?:\/\/[^\s)]+)/g;

const renderBody = (text) => {
    const parts = text.split(URL_REGEX);
    return parts.map((part, i) => {
        if (URL_REGEX.test(part)) {
            URL_REGEX.lastIndex = 0;
            return (
                <a
                    key={i}
                    href={part}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[var(--primary)] underline decoration-[var(--primary)]/40 underline-offset-2 hover:decoration-[var(--primary)] break-all"
                >
                    {part}
                </a>
            );
        }
        return <span key={i}>{part}</span>;
    });
};

export const LegalPage = ({ section, testIdPrefix = "legal-page" }) => {
    const { t } = useLang();

    return (
        <div
            data-testid={testIdPrefix}
            className="min-h-screen bg-[var(--bg)] text-white"
        >
            <Header />

            <main className="max-w-3xl mx-auto px-5 sm:px-8 pt-32 sm:pt-40 pb-20">
                <div className="mb-10 pb-8 border-b border-white/10">
                    {section.subtitle && (
                        <span className="font-display text-[var(--primary)] text-sm tracking-[0.3em]">
                            {section.subtitle}
                            {section.lastUpdated && ` — Last updated: ${section.lastUpdated}`}
                        </span>
                    )}
                    <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-black leading-tight">
                        {section.title}
                    </h1>
                </div>

                <div className="space-y-8">
                    {section.sections.map((s, idx) => (
                        <article
                            key={idx}
                            data-testid={`${testIdPrefix}-section-${idx}`}
                            className="card-dark rounded-2xl p-6 sm:p-8"
                        >
                            <h2 className="text-xl sm:text-2xl font-bold text-white mb-3 leading-snug">
                                {s.heading}
                            </h2>
                            <p
                                className="text-sm sm:text-base text-neutral-300 leading-relaxed whitespace-pre-line"
                                dir="auto"
                            >
                                {renderBody(s.body)}
                            </p>
                        </article>
                    ))}
                </div>

                <div className="mt-14 pt-8 border-t border-white/10 text-center">
                    <Link
                        to="/"
                        data-testid={`${testIdPrefix}-cta`}
                        className="inline-flex items-center gap-2 btn-primary px-6 py-3 rounded-full text-sm font-bold"
                    >
                        {t.header.cta}
                    </Link>
                </div>
            </main>

            <Footer />
        </div>
    );
};
